import { BaseClient } from '../base-client.js';
import { BASE_URLS } from '../../config';

class SubAuthClient extends BaseClient {
  constructor(config) {
    super(config);
    this.baseUrl = this.baseUrl || BASE_URLS.SUB_AUTH_API;
  }

  resetPasswordStart(username) {
    const url = 'password/reset';
    const data = {
      username
    };
    return this.post({ url, data });
  }

  // some unique url we will send for mobile during password reset so that they can intercept the request
  mobileResetPasswordPing(username, passwordResetted) {
    const url = 'mobile/password/reset';
    const params = {
      username,
      password_resetted: passwordResetted
    };
    const data = {
      username
    };
    return this.post({ url, data, params });
  }

  cookiesSynchronizationPing(sessionValid, cookiesUpdated) {
    const url = 'mobile/cookies-synchronization';
    const params = {
      session_valid: sessionValid,
      cookies_updated: cookiesUpdated
    };
    return this.post({ url, params });
  }

  mobileSSOLoginSuccessPing() {
    const url = 'mobile/sso/success';
    const data = {
      success: true
    };
    return this.post({ url, data });
  }

  mobileSSOLoginFinishedPing(success, message) {
    const url = 'mobile/sso/finish-authentication';

    const params = {
      is_success: success,
      message: message
    };

    return this.post({ url, params });
  }

  getCookieValue(cookieName) {
    const url = `cookies/${cookieName}`;
    return this.get({ url });
  }

  setAnonymousCookies() {
    const url = `debug/cookies/set`;
    return this.get({ url });
  }

  deleteCookies() {
    const url = `debug/cookies/clear`;
    return this.get({ url });
  }
}

export { SubAuthClient };
